import { createContext } from 'react';

const WatercraftContext = createContext({});

export default WatercraftContext;